import { parse } from 'date-fns';

export const formatCurrency = (value: number): string => {
  if (value === null || isNaN(value)) {
    return '$0';
  }
  return `$${value.toLocaleString()}`;
};

export const formatCodeInput = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]/g, '').slice(0, 6);
};

export const formatNumber = (value?: number) => {
  if (value === null || isNaN(value ?? NaN)) {
    return '$0';
  }
  const formattedValue = (value ?? 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
  return `$${formattedValue}`;
};

export const convertToNumber = (value: string) => {
  if (!value) return 0;
  const cleanedString: string = value.replace(/[$,]/g, '');
  const numberValue: number = parseFloat(cleanedString);
  return isNaN(numberValue) ? 0 : Math.round(numberValue);
};

export const formatSSNInput = (input: string): string => {
  const digitsOnly = input.replace(/\D/g, '').slice(0, 9);

  if (digitsOnly.length === 0) return '';
  if (digitsOnly.length <= 3) return digitsOnly;
  if (digitsOnly.length <= 5) return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
  return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 5)}-${digitsOnly.slice(5)}`;
};

export const convertToDate = (value: string): Date | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const date = parse(value, 'MM/dd/yyyy', new Date());

  if (isNaN(date.getTime())) {
    return null;
  }

  return date;
};
